import { render, staticRenderFns } from "./BloodResultDataTable.vue?vue&type=template&id=3a9afe90"
import script from "./BloodResultDataTable.vue?vue&type=script&lang=js"
export * from "./BloodResultDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports